export class AnalyticsError {
    type: string;
    message: string;
    constructor(type: "bet" | "other", message: string) {
        this.type = type;
        this.message = message;
    }
}
